import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Baoliao from "../pages/baoliao/page";
import ArticleDetail from "../pages/article/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "baoliao", element: <Baoliao /> },
      { path: "baoliao/:id", element: <ArticleDetail /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;